/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bs-grid';
import BodyClassName from 'react-body-classname';
import Helmet from 'react-helmet';
import WindowSize from 'react-window-size';
// import { Element, scroller } from 'react-scroll';
// import Waypoint from 'react-waypoint';

import Page from '../components/Page';
import Space from '../components/Space';
// import Footer from '../components/Footer';
import LandingBg from '../components/Stream';
// import ShowMenuMixin from '../mixins/ShowMenuMixin';
// import { COLORS } from '../../constants';

// import Features from './Build/Features';
// import Navbar from './Build/Navbar';
// import Links from './Build/Links';
// import Shapes from './Build/Shapes';
// import Layouts from './Build/Layouts';
// import Extras from './Build/Extras';

class Landing extends Component {
  // displayName: 'Build',

  // state: {
  //   renderCharts: false,
  //   activeSection: null,
  // },

  // componentDidMount() {
  //   if (this.props.match.params.section) this.handleScroll(this.props.match.params.section);
  //   this.interval = setInterval(() => {
  //     this.setState({ rerender: Math.random() });
  //   }, 5000);
  // },

  // componentWillReceiveProps(nextProps) {
  //   if (nextProps.match.params.section && nextProps.match.params.section !== this.props.match.params.section) {
  //     this.handleScroll(nextProps.match.params.section);
  //   }
  // },

  // componentWillUnmount() {
  //   clearInterval(this.interval);
  // },

  // handleScroll(target) {
  //   scroller.scrollTo(target, {
  //     duration: 800,
  //     delay: 100,
  //     smooth: true,
  //     offset: -110,
  //   });
  // },

  // getSideLength(columnCount = 3) {
  //   const { windowWidth } = this.props;
  //   switch (columnCount) {
  //     case 3: {
  //       let sideLength = 340;
  //       if (windowWidth < 1200) sideLength = 270;
  //       if (windowWidth < 992) sideLength = 210;
  //       if (windowWidth < 768) sideLength = 258;
  //       if (windowWidth < 570) sideLength = windowWidth - 100;
  //       if (windowWidth === 0) sideLength = 340;
  //       return sideLength;
  //     }
  //     case 2: {
  //       let sideLength = 440;
  //       if (windowWidth < 1200) sideLength = 330;
  //       if (windowWidth < 768) sideLength = 288;
  //       if (windowWidth < 570) sideLength = windowWidth - 100;
  //       if (windowWidth === 0) sideLength = 340;
  //       return sideLength;
  //     }
  //   }
  // },

  render() {
    const { windowWidth, windowHeight } = this.props;
    // const sideLengthThree = this.getSideLength();
    // const sideLengthTwo = this.getSideLength(2);
    return (
      <BodyClassName className={'no-padding'}>
        <Page fluid name="page-landing page-build">
          <Helmet
            title="Potion.js - React + D3"
            meta={[
              {
                property: 'og:url',
                content: 'http://numberpicture.com/build',
              },
              {
                property: 'og:title',
                content: 'Potion.js - React + D3',
              },
              {
                property: 'og:description',
                content: 'Low-level React components for declaratively composing animated, interactive SVG visualizations.',
              },
              {
                name: 'twitter:title',
                content: 'Potion.js - React + D3',
              },
              {
                name: 'twitter:description',
                content: 'Low-level React components for declaratively composing animated, interactive SVG visualizations.',
              },
              {
                charSet: 'utf-8',
              },
            ]}
          />

          <Container fluid className="above-fold">

            <LandingBg
              width={windowWidth}
              height={windowHeight}
              className="landing-bg"
              transform={{ rotate: [180, windowWidth / 2, windowHeight / 2] }}
            />

            <Space />

            <Row>
              <Col lg={6} offsetLg={3}>
                <h1>Potion.js</h1>
                <h2>Low-level building blocks and utilities for constructing animated visualizations with React & D3.</h2>
                <Space half />
                {/* <Link to="/docs" className="btn btn-primary btn-lg">Get Started</Link> */}
                {/* <Space /> */}
              </Col>
            </Row>
          </Container>

          <Container>
            {/* <Waypoint
              onEnter={() => {
                this.setState({ activeSection: 'features' });
              }}
              onLeave={({ currentPosition, previousPosition }) => {
                if (currentPosition === 'above' && previousPosition === 'inside') {
                  return;
                }
                this.setState({ activeSection: false });
              }}
            > */}
            <div>
              <Space half />

              {/* <Element name="features"> */}
              <Row>
                <Container>
                  <Row>
                    <Col md={4} sm={6}>
                      <h3>Shapes</h3>
                      <p>
            SVG and D3 shape primitives for composing any visualization.
                      </p>
                      <Space half />
                    </Col>
                    <Col md={4} sm={6}>
                      <h3>Layouts</h3>
                      <p>Layouts and Collections for joining shapes to datasets.</p>
                      <Space half />
                    </Col>
                    <Col md={4} sm={6}>
                      <h3>Animation</h3>
                      <p>Declaratively animate shapes on enter, update and exit with React Motion.</p>
                      <Space half />
                    </Col>
                    <Col md={4} sm={6}>
                      <h3>Interaction</h3>
                      <p>
            Visualizations can be made interactive using built-in React event handlers.
                      </p>
                      <Space half />
                    </Col>
                    <Col md={4} sm={6}>
                      <h3>Isomorphic</h3>
                      <p>Full support for server-side rendering out of the box.</p>
                      <Space half />
                    </Col>
                    <Col md={4} sm={6}>
                      <h3>Extras</h3>
                      <p>Comes with extra utility components for rendering axes, patterns and annotations.</p>
                      <Space half />
                    </Col>
                    <Col md={4} sm={6}>
                      <h3>React Native</h3>
                      <p>Out-of-the-box support for React Native through component injection.</p>
                      <Space half />
                    </Col>
                    <Col md={4} sm={6}>
                      <h3>Extensibility</h3>
                      <p>All component primitives are extensible and provide an interface for customizability.</p>
                      <Space half />
                    </Col>
                    <Col md={4} sm={6}>
                      <h3>Accessability</h3>
                      <p>All library components enable accessability by letting you pass custom props to them.</p>
                      <Space half />
                    </Col>
                  </Row>
                </Container>
              </Row>
              {/* </Element> */}

              <Space half />
            </div>
            {/* </Waypoint> */}

            {/* <Waypoint
              onEnter={() => {
                this.setState({ activeSection: 'components' });
              }}
              onLeave={({ currentPosition, previousPosition }) => {
                if (currentPosition === 'below' && previousPosition === 'inside') {
                  this.setState({ activeSection: 'features' });
                  return;
                }
                if (currentPosition === 'above' && previousPosition === 'inside') {
                  return;
                }
                this.setState({ activeSection: null });
              }}
            > */}
            <div>
              {/*   <Element name="components">
                  <Shapes sideLength={sideLengthThree} />
                </Element>
                <Space />

                <Layouts sideLength={sideLengthTwo} />
                <Space />

                <Extras sideLength={sideLengthTwo} />
                <Space />

                <Links /> */}
              <Space />
            </div>
            {/* </Waypoint> */}

          </Container>
          {/* <Footer /> */}
        </Page>
      </BodyClassName>
    );
  }
}

export default WindowSize(Landing);




// WEBPACK FOOTER //
// ./src/pages/index.js